import { QUERY_KEYS } from 'api/query-keys';
import { UpdateShiftRequestDto } from 'api/services/shift/shift-service.dto';
import { sharedShiftService } from 'api/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { useSiteDetection } from 'shared/hooks';

type ShiftMutationOptions = UseMutationOptions<void, Error, UpdateShiftRequestDto>;

export const useUpdateShift = () => {
  const queryClient = useQueryClient();
  const { site } = useSiteDetection();

  const mutationFn = async (shift: UpdateShiftRequestDto) =>
    await sharedShiftService.updateShift(site, shift);
  const options: ShiftMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  };

  return useMutation(mutationFn, options);
};
